module.exports = __webpack_public_path__ + "img/server-03.e05674ad.svg";